export default {
    props: {
        value: Boolean,
        title: String,
        mode: String
    },
    data() {
        return {
            modes: { add: 'Add', edit: 'Update' },
        }
    },
    computed: {
        visible: {
            get() { return this.value; },
            set(val) { this.$emit("input", val); },
        },
    },
    methods: {
        cancel() {
            this.visible = false;
        },
    }
};